import { GlButton, GlTooltipDirective } from '@gitlab/ui';
export default {
    name: 'WorkItemDisplaySettingsButton',
    components: {
        GlButton
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        selected: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'click'
    ]
};
